import { render, staticRenderFns } from "./GeneralData.vue?vue&type=template&id=16d1a894&scoped=true"
import script from "./GeneralData.vue?vue&type=script&lang=js"
export * from "./GeneralData.vue?vue&type=script&lang=js"
import style0 from "./GeneralData.vue?vue&type=style&index=0&id=16d1a894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d1a894",
  null
  
)

export default component.exports